import BarcodeSearch from 'components/common/barcodeSearch'
import { uploadBarcodeSearchFile } from 'utils/api/masterDataApi'

// Re-export the shared barcode-search constants/helpers so existing imports
// from this module keep working (masterData.tsx, masterDataTable.tsx).
export {
  BARCODE_QUERY_KEY,
  BARCODE_TOKEN_KEY,
  BARCODE_COUNT_KEY,
  BARCODE_SEARCH_EXPIRED,
  BARCODE_ERROR_MESSAGES,
  getBarcodeErrorCode,
} from 'components/common/barcodeSearch/constants'

const MasterDataBarcodeSearch = () => (
  <BarcodeSearch uploadFile={uploadBarcodeSearchFile} />
)

export default MasterDataBarcodeSearch
